<script>
    import { getContext } from 'svelte';
    import { Policy } from "@Store";
    import Question from "@components/Question.svelte";
    import 'animate.css';
    import { computeLegalExpenseValid } from '@routes/validators/validator';
    const CONTEXT = getContext('CONTEXT');

    $: questions = $Policy.questions ? $Policy.questions : [];
    // Now you can access any question efficiently
    $: normalize = (s) => (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
    $: legal_expense_question = questions.find(q =>
        normalize(q.question).includes('do you require additional legal expense insurance')
    );

    $: legal_expense_valid = computeLegalExpenseValid($Policy);

    // Update CONTEXT when validation changes
    $: {
        CONTEXT.routeValidation.update(validation => ({
            ...validation,
            legalexpense: legal_expense_valid
        }));
    }

    function handleAnswer(e) {
        CONTEXT.handleAnswer(e);
    }


</script>

<div class="page-container">
    <div class="questions-wrapper">
        <!-- APPLICANT QUESTIONS -->
        {#if legal_expense_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={legal_expense_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}

    </div>
</div>

<style>
    .page-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    .questions-wrapper {
        width: 100%;
        max-width: 500px;
        margin-bottom: 2rem;
    }
</style>